import * as tslib_1 from "tslib";
// Core components
import { OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatInput } from '@angular/material';
// Third party components
import { FieldType } from '@ngx-formly/material';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
// Custom components
import { ConfirmDialogComponent } from 'src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { ManualAddressDialogComponent } from 'src/app/shared/components/dialogs/manual-address-dialog/manual-address-dialog.component';
import { HelperService } from 'src/app/shared/services/helper.service';
// import { Options } from 'ngx-google-places-autocomplete/objects/options/options';
// @see https://stackblitz.com/edit/angular-g9txuh-zysdfi?file=src/app/autocomplete-type.component.ts
var GoogleAutocompleteTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(GoogleAutocompleteTypeComponent, _super);
    /**
    [options]="googleOptions"
    googleOptions: Options = {
      types: [],
      componentRestrictions: {
        country: 'IT',
      },
      fields: [
        'address_components',
        'geometry',
      ],
      bounds: null,
      strictBounds: null,
    };
    **/
    function GoogleAutocompleteTypeComponent(toastrService, helperService, translateService, dialog) {
        var _this = _super.call(this) || this;
        _this.toastrService = toastrService;
        _this.helperService = helperService;
        _this.translateService = translateService;
        _this.dialog = dialog;
        _this.subscriptions = [];
        _this.formControl2 = new FormControl();
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    GoogleAutocompleteTypeComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        if (this.to.disabled) {
            this.formControl2.disable();
        }
        if (this.formControl.value) {
            this.formControl2.setValue(this.helperService.getFormattedAddress(this.formControl.value));
        }
        this.subscriptions.push(this.formControl.valueChanges.subscribe(function (res) {
            if (res) {
                var formattedAddress = _this.helperService.getFormattedAddress(res);
                if (formattedAddress) {
                    _this.formControl2.setValue(formattedAddress);
                }
                else {
                    _this.handleInvalidAddressEntry(res);
                }
            }
        }));
        // Subscribe to formControl2. This is used to allow
        // user to delete an address
        this.subscriptions.push(this.formControl2.valueChanges.subscribe(function (res) {
            if (res === '') {
                _this.formControl.setValue(undefined);
            }
        }));
    };
    /**
     * After view init logic
     *
     * @since 1.0.0
     */
    GoogleAutocompleteTypeComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    GoogleAutocompleteTypeComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle the address change event in a Google Autocomplete field
     * and set the appropriate value to his components
     *
     * @see https://www.npmjs.com/package/ngx-google-places-autocomplete
     *
     * @since 1.0.0
     *
     * @param address the Address obj returned from Google Maps APIs
     * @param controlName The name of the formControl used to get the Address
     */
    GoogleAutocompleteTypeComponent.prototype.handleAddressChange = function (address) {
        var formattedAddress = this.getAddressValues(address);
        if (formattedAddress) {
            this.formControl.setValue(formattedAddress);
        }
    };
    /**
     * Create a "CustomAddress" object using values
     * provided from Google Autocomplete result and returns it
     *
     * @since 1.0.0
     */
    GoogleAutocompleteTypeComponent.prototype.getAddressValues = function (address) {
        var e_1, _a;
        if (!address.address_components) {
            this.toastrService.error(this.translateService.instant('common.errors.invalid_address'));
            return;
        }
        var addressValues = {
            route: '',
            streetNumber: '',
            city: '',
            postalCode: '',
            countryCodeTwo: '',
            latLng: '',
        };
        try {
            for (var _b = tslib_1.__values(address.address_components), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                if (item.types.includes('route')) {
                    addressValues.route = item.long_name;
                }
                if (item.types.includes('street_number')) {
                    addressValues.streetNumber = item.long_name;
                }
                if (item.types.includes('locality')) {
                    addressValues.city = item.long_name;
                }
                if (item.types.includes('postal_code')) {
                    addressValues.postalCode = item.long_name;
                }
                if (item.types.includes('country')) {
                    addressValues.countryCodeTwo = item.short_name;
                }
                if (item.types.includes('administrative_area_level_1')) {
                    addressValues.administrativeArea1 = item.long_name;
                }
                if (item.types.includes('administrative_area_level_2')) {
                    addressValues.administrativeArea2 = item.long_name;
                }
                if (item.types.includes('administrative_area_level_3')) {
                    addressValues.administrativeArea3 = item.long_name;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (address.geometry && address.geometry.location) {
            var lat = address.geometry.location.lat();
            var lng = address.geometry.location.lng();
            addressValues.latLng = lat + "," + lng;
        }
        return addressValues;
    };
    /**
     * Once user select an address from google autocomplete addresses list
     * we check fi that address has all needed data. If not we call this
     * method that ask user to check entered data or to manually insert
     * address data
     *
     * @since 1.0.0
     */
    GoogleAutocompleteTypeComponent.prototype.handleInvalidAddressEntry = function (googleRes) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('dialogs.googleAutocomplete.title'),
                message: this.translateService.instant('dialogs.googleAutocomplete.message'),
                btnOkText: this.translateService.instant('dialogs.googleAutocomplete.btnOkText'),
                btnOkIcon: 'fa-reply',
                btnCancelText: this.translateService.instant('dialogs.googleAutocomplete.btnCancelText'),
                btnCancelIcon: 'fa-edit',
                btnCancelColor: 'accent',
            },
            width: '500px',
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res2) {
            // Rese values
            _this.formControl.setValue('', { emitEvent: false });
            _this.formControl2.setValue('', { emitEvent: false });
            // Open a custom popup used to let user manually fill address data
            if (!res2) {
                _this.openManualAddressDialog(googleRes);
            }
            dialogRef.close();
        });
    };
    /**
     * Open a new dialog used to let user manually fill address
     * data and save that data
     *
     * @since 1.0.0
     */
    GoogleAutocompleteTypeComponent.prototype.openManualAddressDialog = function (googleRes) {
        var _this = this;
        var addressData = {};
        if (googleRes) {
            addressData.route = googleRes.route;
            addressData.streetNumber = googleRes.streetNumber;
            addressData.postalCode = googleRes.postalCode;
            addressData.city = googleRes.city;
            addressData.administrativeArea1 = googleRes.administrativeArea1;
            addressData.administrativeArea2 = googleRes.administrativeArea2;
            addressData.administrativeArea3 = googleRes.administrativeArea3;
            addressData.countryCodeTwo = googleRes.countryCodeTwo;
        }
        // @todo completare
        var dialogRef = this.dialog.open(ManualAddressDialogComponent, {
            data: tslib_1.__assign({}, addressData),
            width: '600px',
            autoFocus: false,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res2) {
            var formattedAddress = _this.helperService.getFormattedAddress(res2);
            _this.formControl.setValue(res2);
            _this.formControl2.setValue(formattedAddress);
        });
    };
    /**
     * Once formControl2 has been clicked just make the label
     * float
     *
     * @todo this cause label to float even once user click in
     * some other field and it's not good. Would be nice to find
     * a way to make label disappear once user defocus the input
     *
     * @since 1.0.0
     */
    GoogleAutocompleteTypeComponent.prototype.onClick = function () {
        this.formField.floatLabel = 'always';
    };
    return GoogleAutocompleteTypeComponent;
}(FieldType));
export { GoogleAutocompleteTypeComponent };
